import util from '../util';

window._submit = (event, form, next) => {
    if (event) {
        event.preventDefault();
        if (!form) form = event.target;
    }
    const button = form.querySelector('[type="submit"]');

    // Some fields may have a pending fixup event handler yet to be fired (eg: codepicker's onblur')
    // Walk the fields and check they don't are good to go, else sleep on it.
    if (button.getAttribute('disabled')) {
        return;
    }

    loading.save();

    const disabledButton = button;
    disabledButton.setAttribute('disabled', true);
    let waitingEl;
    const formEls = form.elements;
    try {
        for (let idx = 0, len = formEls.length; idx < len; idx++) {
            if (formEls[idx].fixupPending) {
                waitingEl = formEls[idx];
                break;
            }
        }
    } catch (e) {
        disabledButton.removeAttribute('disabled');
    }
    if (waitingEl) {
        disabledButton.removeAttribute('disabled');
        setTimeout(() => {
            window._submit(event, form, next);
        }, 100);
    } else {
        __submit(form, next);
    }
};

function __submit(form, next) {
    const disabledButton = form.querySelector('[type="submit"]');
    if (!required.isValid()) {
        loading.remove();
        disabledButton.removeAttribute('disabled');
        notification.notify('Error', 'Please complete all required fields', -10);
        return;
    }
    ajax({
        url: `${util.urlCurrentDirname()}submit`,
        method: 'POST',
        formData: new FormData(form),
        documentType: 'json',
        callback(response) {
            disabledButton.removeAttribute('disabled');
            if (response.status.value < 0) {
                loading.remove();
                notification.notify('Error', response.status.text, response.status.value);
                const { id } = response.status;
                if (id) {
                    document.getElementById(response.status.id).style.backgroundColor = 'rgba(0,0,0,0.2)';
                }

                if (next) {
                    next(new Error(response.status.text), response);
                }
            } else if (document.querySelector('form').getAttribute('data-label-page') === 'recruitment/apply/withdraw') {
                notification.notifyOnVisit('Success', 'Application withdrawn', 0);
                window.location = response.redirect;
            } else {
                const isEditForm = form.getAttribute('data-label-mode') === 'edit';
                const pageHeader = form.querySelector('#page-title')?.innerText.toLowerCase();
                const msg = pageHeader
                    ? `${pageHeader.slice(0, 1).toUpperCase()}${pageHeader.slice(1)} ${isEditForm ? 'updated' : 'added'}`
                    : 'Settings updated';
                notification.notifyOnVisit('Success', msg, response.status.value);
                if (next) {
                    loading.remove();
                    next(null, response);
                } else {
                    window.location = response.redirect;
                }
            }
        },
    });
}

window._delete = (button) => {
    loading.del();
    ajax({
        url: `${util.urlCurrentDirname()}del`,
        callback(response) {
            response = JSON.parse(response);
            if (response.status.value < 0) {
                loading.remove();
                notification.notify('Deleted', response.status.text, response.status.value);
            } else {
                const pageHeader = document.querySelector('#page-title').innerText.toLowerCase();
                const msg = `${pageHeader.slice(0, 1).toUpperCase()}${pageHeader.slice(1)} deleted`;
                notification.notifyOnVisit('Deleted', msg, response.status.value);
                window.location = response.redirect;
            }
        },
        documentType: 'text',
        method: 'POST',
        formData: new FormData((button && button.form) || document.forms[0]),
    });
};

document.addEventListener('DOMContentLoaded', () => {
    deduplicateFields();
    const deleteRecordBtn = document.getElementById('btnDelete');
    if (deleteRecordBtn) deleteRecordBtn.addEventListener('click', (evt) => window._delete(evt.target));
});

function deduplicateFields() {
    // Prevent multiple U_VERSION or U_FIELDLIST fields being sent to the server.
    // Delete duplicates, and prefer to keep the first one with a value.
    const { forms } = document;

    util.each(forms, (form) => {

        util.each(['U_VERSION', 'U_FIELDLIST'], (fieldname) => {
            const fields = form.querySelectorAll(`[name=${fieldname}]`);

            if (1 < fields.length) {
                let firstWithValue;

                util.each(fields, (field) => {
                    if (!firstWithValue && field.value) firstWithValue = field;
                });

                const keep = firstWithValue || fields[0];

                util.each(fields, (field) => {
                    if (field === keep) return;
                    field.parentNode.removeChild(field);
                });
            }

        });
    });
}
